<template>
  <table
    v-if="items && items.length > 0"
    class="w-full">
    <thead>
      <tr>
        <th class="text-accent-brown text-left">Artikelname</th>

        <!-- Quality & Quantity Form -->
        <th class="text-accent-brown text-right" v-if="!isDepositForm">Optik</th>
        <th class="text-accent-brown text-right" v-if="!isDepositForm">Geschmack</th>
        <th class="text-accent-brown text-right w-12" v-if="!isDepositForm">SOLL</th>
        <th class="text-accent-brown text-right w-12" v-if="!isDepositForm">IST</th>

        <!-- Deposit Form -->
        <th class="text-accent-brown text-right uppercase" v-if="isDepositForm">Differenz</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in items"
        :key="item.product.id"
        class="border-b border-gray-300">
        <td class="py-1">{{ item.product.name }} ({{ item.product.item_number }})</td>
        <td v-if="!isDepositForm" class="py-1 text-right">
          <svg v-if="item.appearance" class="w-5 h-5 mb-2 mr-2 sm:inline-block">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-checkmark-small"></use>
          </svg>
          <span v-else>-</span>
        </td>
        <td v-if="!isDepositForm" class="py-1 text-right">
          <svg v-if="item.taste" class="w-5 h-5 mb-2 mr-2 sm:inline-block">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-checkmark-small"></use>
          </svg>
          <span v-else>-</span>
        </td>
        <td v-if="!isDepositForm" class="py-1 font-semibold text-right text-accent-brown">{{
          item.product.pivot.quantity
        }}</td>
        <td class="py-1 font-semibold text-right">{{
          isDepositForm ? item.difference ?? '-' : (item.actual ?? item.product.pivot.quantity)
        }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'ProductComparisonTable',
  props: {
    selected: {
      type: Array,
      required: false
    },
    products: {
      type: Array,
      required: true
    },
    isDepositForm: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    items() {
      const result = []

      if (this.selected && this.selected.length > 0) {
        this.selected.map(val => {
          if (this.isDepositForm) {
            result.push({
              product: this.products.find(item => item.id === val.id),
              difference: val.difference,
            })
          } else {
            result.push({
              product: this.products.find(item => item.id === val.id),
              actual: val.actual,
              appearance: val.appearance,
              taste: val.taste
            })
          }
        })
      }

      return result
    }
  }
}
</script>
